import { render } from "./form-wrapper.vue?vue&type=template&id=273c175e&scoped=true"
import script from "./form-wrapper.vue?vue&type=script&lang=js"
export * from "./form-wrapper.vue?vue&type=script&lang=js"

import "./form-wrapper.vue?vue&type=style&index=0&id=273c175e&scoped=true&lang=css"

import exportComponent from "/home/devbuildsseatshopcom/dev.builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273c175e"]])

export default __exports__